'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.directive('capslockCheck', function($document) {

  var isMac, code, shift;
  var CAPSLOCK_CODE = 20;
  var UPPERCASE_CODE_BEGIN = 65;
  var UPPERCASE_CODE_END = 90;
  var LOWERCASE_CODE_BEGIN = 97;
  var LOWERCASE_CODE_END = 122;

  return {
    restrict: 'A',
    link: function(scope, lElement) {

      // This directive is used to detect caps lock on passsword fields.
      // It needs a keyboard event before it can be sure whether caps lock
      // is on or off
      // There are some differences in caps lock behaviour between mac and
      // windows keyboard behaviour
      // Neither OS tracks the caps lock state so a keypress of an alpha
      // character plus a check to see if it was in combination with shift or
      // not is required. In Mac only, pressing caps lock is enough as well.

      // Keyup event with caps lock on Mac always means caps lock is off.
      // In Windows it only means caps lock was toggled so we must know
      // the previous value of caps lock to display an indicator

      $document.on('keyup', function(event) {
        doCheck(event);
        if (code === CAPSLOCK_CODE && event.type === 'keyup' && isMac) {
          scope.capsLock = false;
          setResult();
        }
        else if (code === CAPSLOCK_CODE && !isMac && typeof scope.capsLock
          !== 'undefined') {
          scope.capsLock = !scope.capsLock;
          setResult();
        }
        else {
          scope.capsLock = scope.capsLock;
          setResult();
        }
      });

      // Keydown event with caps lock on Mac always means caps lock is on

      $document.on('keydown', function(event) {
        doCheck(event);
        if (code === CAPSLOCK_CODE && event.type === 'keydown' && isMac) {
          scope.capsLock = true;
          setResult();
        }
      });

      // Only a keypress event allows us to differentiate uppercase and
      // lowercase alpha characters.

      $document.on('keypress', function(event) {
        doCheck(event);

        if (code >= LOWERCASE_CODE_BEGIN && code <= LOWERCASE_CODE_END && event.type === 'keypress') {
          scope.capsLock = shift;
          setResult(scope.capsLock);
        }

        // In Mac only, if caps lock is on the shift key is ignored

        else if (code >= UPPERCASE_CODE_BEGIN && code <= UPPERCASE_CODE_END && !(shift && isMac) &&
          event.type === 'keypress') {
          scope.capsLock = !shift;
          setResult();
        }
        else {
          scope.capsLock = scope.capsLock;
          setResult();
        }

      });

      function doCheck(thisEvent) {
        isMac = false;
        code = thisEvent.charCode || thisEvent.keyCode;
        shift = thisEvent.shiftKey;

        if (/Mac|iPad|iPhone|iPod/.test(navigator.platform)) {
          isMac = true;
        }
      }

      function setResult() {
        if (scope.capsLock === true) {
          lElement.toggleClass('input__caplock', true);
        }

        // Display no indicator both when caps lock is undefined
        // and when it is off.

        else {
          lElement.toggleClass('input__caplock', false);
        }
      }
    }
  };
});
